module.exports = __webpack_public_path__ + "static/img/home4.bcb4b4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/home4.jpg
// module id = /yAZ
// module chunks = 0